<template>
    <div class="flex-con is-grow xs-pad-lr filters-con">
        <div class="is-narrow">
            <h5 class="heading m-b-n is-size-6">Filters</h5>
        </div>
        <slot name="first"></slot>
        <div class="contain-filters-col">
            <div class="flex-con is-grow applied-filter-con">
                <div
                    v-for="(filters, groupIndex) in groupedAppliedFilters"
                    :key="groupIndex"
                    class="is-narrow"
                >
                    <div class="flex-con">
                        <div
                            v-if="groupIndex !== 0 && groupIndex <= groupedAppliedFilters.length - 1 && groupedAppliedFilters.length > 1"
                            class="and"
                        >
                            AND
                        </div>
                        <div>
                            <div
                                class="flex-con is-wrap is-grow or-group"
                                :class="{ 'highlight-group' : filters.length > 1 }"
                            >
                                <div
                                    v-for="(f, i) in filters"
                                    :key="$uniqueId(f)"
                                    class="is-narrow"
                                >
                                    <div
                                        v-if="i !== 0 && i <= filters.length - 1 && filters.length > 1"
                                        class="or"
                                    >
                                        OR
                                    </div>
                                    <div
                                        class="applied-filter"
                                    >
                                        <div class="flex-con">
                                            <div
                                                class="remove-col"
                                                @click="remove(f)"
                                                title="Remove this filter"
                                            >
                                                <i class="delete is-small"></i>
                                            </div>
                                            <div class="label-col">
                                                {{f.label}}
                                            </div>
                                            <div
                                                v-if="f.isDynamicFilter && filters.length === 1"
                                                class="add-col"
                                                ref="df"
                                            >
                                                <div
                                                    class="add-col-button"
                                                    @click="toggle($refs.df[i], f)"
                                                    :title="orTooltip"
                                                >
                                                    <i class="fa fa-plus-circle"></i>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div
                                    v-if="filters[0].isDynamicFilter && filters.length > 1"
                                    class="add-col"
                                    :ref="`dfg-${groupIndex}`"
                                >
                                    <div
                                        class="add-col-button"
                                        @click="toggle($refs['dfg-' + groupIndex][0], filters[filters.length - 1], true)"
                                        :title="orTooltip"
                                    >
                                        <i class="fa fa-plus-circle"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <dynamic-filter
                v-if="addToFilter"
                ref="dynamicFilter"
                class="fixed-dynamic-filter"
                :style="dfStyles"
                :available-fields="availableFields"
                condition-name="Or"
                @add="$emit('add-dynamic-filter', {...$event, attachToGroup : addToFilter.group })"
                @update-condition="$emit('update-condition', $event)"
                @close="addToFilter = null"
            />

        </div>
    </div>
</template>

<script>
import DynamicFilter from "$flx/components/abstract-search/components/DynamicFilter";
import EventBus from '$flx/event-bus';
export default {
    name : "AppliedFilters",
    components : {DynamicFilter},
    props : {
        groupedAppliedFilters : {
            type : Array,
            required : true,
        },
        availableFields : {
            type : Object,
            required : true,
        },
    },
    data () {
        return {
            addToFilter : null,
            dfStyles : {},
            orTooltip : 'Add another condition as an OR',
        };
    },
    beforeMount () {
        EventBus.on(EventBus.EVENT.ABSTRACT_SEARCH_DYNAMIC_FILTER_OPEN, (context) => {
            if(!context.fromApplied) {
                this.addToFilter = null;
            }
        });
    },
    methods : {
        closeAddToFilterIfActive (filter) {
            if(this.addToFilter && this.addToFilter.group === filter.group) {
                this.$refs.dynamicFilter.close();
                this.addToFilter = null;
                return true;
            }
            return false;
        },
        remove (filter) {
            this.closeAddToFilterIfActive(filter);
            this.$emit(filter.onRemoveEventName, filter);
        },
        toggle (ref, filter, isForGroup) {
            if(this.closeAddToFilterIfActive(filter)) {
                return;
            }
            EventBus.emit(EventBus.EVENT.ABSTRACT_SEARCH_DYNAMIC_FILTER_OPEN, { fromApplied : true });
            const leftOffsetPush = isForGroup ? 4 : 0;
            this.dfStyles = {
                top : (ref.getBoundingClientRect().top + 24) + 'px',
                left : (ref.getBoundingClientRect().left + leftOffsetPush) + 'px',
            };
            this.addToFilter = filter;
        },
    },
}
</script>

<style lang="scss" scoped>
    /deep/ .fixed-dynamic-filter {
        position:fixed;
        .display-con {
            position:relative;
        }
    }
    .filters-con {
        height:46px;
    }
    .contain-filters-col {
        min-width:0;
        overflow:auto;
    }
</style>
